fx.ns("shared.screens", class HardCover extends shared.screens.BaseChoiceScreen 
{
    constructor()
    {
        super();
        
        this.showNext = false;
        this.showBack = fx.get("mode") == "creating";

        this.styleChoice = "square";

        this.containerHeight = 450;
        this.valign = "top";
        this.title = fx.text("Quel type d'ouverture souhaitez-vous?");
    }

    create()
    {
        super.create();

        this.build();
    
        let hardCover = this.data.creation.getCover( models.ProductBook.HARD);
        let layflatCover = this.data.creation.getCover( models.ProductBook.LAYFLAT);

        this.hardCoverChoice = new shared.components.ProductChoice("square noborder", hardCover, fx.get("assets").albumCoverHard, fx.text("Ouverture normale"), fx.text("De $ à $ pages", hardCover.min_pages,  hardCover.max_pages));
        this.layoutFlatCoverChoice = new shared.components.ProductChoice("square noborder", layflatCover, fx.get("assets").albumCoverHardLayFlat, fx.text("Ouverture à plat"), fx.text("De $ à $ pages", layflatCover.min_pages,  layflatCover.max_pages), "<strong>+" + this.data.creation.getExtraPriceLayFlat(this.data.choosedFormat) + " €</strong>");
        
        this.addChoice(this.hardCoverChoice, {width: 300, height : 310, left : fx.browser.isDesktop ? 0 : "center"} );
        this.addChoice(this.layoutFlatCoverChoice, {width: 300, height : 310, left : fx.browser.isDesktop ? 0 : "center"} );
    }

    onChoiceClicked(obj)
    {      
        if (fx.get("mode") == "creating")
        {
            this.data.choosedCover = obj.cover.code;
            this.data.event("next-step");
        } 
        else
        {
            let coverChoice = this.data.creation.coverChoices.find({option_id : this.data.creation.coverChoices.getOptionId(obj.cover.code)});
            this.data.creation.updateCover(coverChoice);

            // updateCover refuses a cover the album has too many / too few pages for
            if (this.data.creation.optionid == coverChoice.option_id)
                this.data.coverChoicePending = false;

            if (this.data.preOrderChoices) // screen asked by the order button, not by the info panel
            {
                if (!this.data.coverChoicePending)
                    this.data.event("creation-choice-done");
            }
            else
            {
                this.trigger("reset-navigation");
                this.data.event("cover-selection-finished");
            }
        }
    }
});